/**
 * Swedish-locale comparison for every name a list shows: members, districts, species,
 * plan rows. Legacy listed names in Swedish order, so å, ä and ö sort after z rather
 * than beside a and o. One shared instance keeps every list in the same order as the
 * plan editor, and builds the collator once instead of on every sort. Case is ignored, as
 * the API's SwedishOrder ignores it, so a name differing only in case falls to the same
 * id tie-break on both sides; å, ä and ö still differ from a and o.
 */
export const swedishCollator = new Intl.Collator('sv', { sensitivity: 'accent' })
